<template>
    <div
        class="fullwidth-wrapper fullwidth-wrapper--momentum"
        :style="{minHeight: minSectionHeight + 'px'}">
        <div
            :id="id"
            class="momentum-chart balloon-chart fullwidth-wrapper__content"
            @mousedown="handleMouseDown"
            @mouseup="handleMouseUp"
            @mousemove="handleMouseMove"
            @mouseleave="handleMouseLeave">
        </div>
        <div class="transit-btn arrow-main">
            <ul class="buttons-list buttons-list--row buttons-list--justify arrow-sub">
                <li
                    v-if="iDay > 1"
                    class="buttons-list__item arrowLeft">
                    <svg
                        @click="$emit('prev-year')"
                        width="24"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="#f586cb"
                        fill-rule="evenodd"
                        cursor="pointer"
                        clip-rule="evenodd"><path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z"/></svg>
                </li>
                <li
                    v-if="iDay < userAge && iDay < maxIday"
                    class="buttons-list__item buttons-list__item--end arrowRight">
                    <svg
                        @click="$emit('nxt-year')"
                        width="24"
                        height="24"
                        fill="#f586cb"
                        cursor="pointer"
                        xmlns="http://www.w3.org/2000/svg"
                        fill-rule="evenodd"
                        clip-rule="evenodd"><path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z"/></svg>
                </li>
            </ul>
        </div>
        <div style="margin-top: 196px;"></div>
    </div>
    
</template>

<script>
// @ is an alias to /src

import Vue from "vue";

import d3 from "@/utils/d3/d3.js";

import dayjs from "dayjs";
import hexToRgba from "hex-to-rgba";

import {ELEMENTS} from "@/utils/constants/elements.js";
import {DOMAINS} from "@/utils/constants/domains.js";
import { randomDate } from "@/utils/helpers/date.js";

var dayOfYear = require("dayjs/plugin/dayOfYear");
dayjs.extend(dayOfYear);

var isBetween = require("dayjs/plugin/isBetween");
dayjs.extend(isBetween);

import { v4 as uuidv4 } from "uuid";

export default {
    name: "YearDetailChart",
    props: {
        data: {
            type: Array,
            required: true
        },
        events: {
            type: Array,
            required: true
        },
        userBirthdate: {
            type: String,
            required: true
        },
        iday: {
            type: Number,
            required: true
        },
        iDay: {
            type: Number,
            required: true
        },
        maxIday: {
            type: Number,
            required: true
        },
        userAge: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            x: 0,
            y: 0,
            top: 0,
            left: 0,
            isMouseDown: false,
            isDragEnable: false,
            id: "years-details-chart-" + uuidv4()
        };
    },
    computed: {
        // loggedUser
        // Current logged user
        loggedUser() {
            return this.$store.getters["userModule/getUser"];
        },
        screenWidth() {
            return this.$store.getters["responsiveModule/getCurrentWindowWidth"];
        },
        currentYearUserBirthdate() {

            const monthDay = this.userBirthdate.substr(5);
            const idayYear = dayjs(this.userBirthdate).add(this.iday, "year").year();

            return `${idayYear}-${monthDay}`;
        },
        currentYearRange() {
            const date = this.data.map((item) => {
                return item.datecalendar;
            });

            return {
                "start": date[0],
                "end": dayjs(date[date.length - 1]).add(1, "month")
            };

        },
        cleanedData() {
            const cleanedData = this.data.map((item) => {
                const x = d3.timeParse("%Y%m%d")(item.datecalendar);

                return {
                    "x": x,
                    "y": (item.y) ? item.y : 0,
                    "value": item.score,
                    "element": item.element,
                    "color": "#" + item.couleur,
                    "domain": item.domaine,
                    "desc": item.desc,
                };
            });

            return cleanedData;
        },
        currentEvents() {
            if (this.events.length > 0) {
                const events = this.events.filter((item) => {
                    if (item.age === this.iday) {
                        return true;
                    }
                });

                return events;
            }

            return;
        },
        cleanedEvents() {
            if (this.currentEvents) {
                const cleanedEvents = this.currentEvents.map((item) => {
                    return {
                        "id_event": item.id_event,
                        "x": d3.timeParse("%Y%m%d")(item.event_date),
                        "y": (item.y) ? item.y : 1,
                        "category": item.category,
                        "subcategory": item.subcategory,
                        "detail": item.detail,
                        "id_user": item.id_user
                    };
                });

                return cleanedEvents;
            }

            return [];
        },
        minSectionHeight() {
            if (this.currentEvents) {
                return 578 + (this.currentEvents.length * 60);
            } else {
                return 578;
            }
        }
    },
    watch: {
        data() {
            this.resetLifecycleChart();
            this.buildLifecycleChart();
        },
        screenWidth(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.resetLifecycleChart();
                this.buildLifecycleChart();
            }
        }
    },
    mounted: function() {
        this.buildLifecycleChart();
    },
    methods: {
        resetLifecycleChart() {
            const wrapper = document.getElementById(this.id);
            wrapper.innerHTML = "";
        },
        buildLifecycleChart() {
            Vue.nextTick(() => {

                const radiusRange = this.cleanedData.map((d) => {
                    return d.value * 2;
                });

                const maxRadiusValueRange = Math.max(...radiusRange);

                const yValueRange = d3.extent(this.cleanedData, function(d) {
                    return d.y;
                });

                const adaptedYValueRange = [0, yValueRange[1] + 10];

                // Extra Height
                const eventsY = this.cleanedEvents.map((item) => {
                    return item.y;
                });
                const eventYMax = (eventsY.length > 0) ? Math.max(...eventsY) : 0;

                let eventExtraHeight = 0;

                if (eventYMax === 1) {
                    eventExtraHeight = 125;
                } else if (eventYMax === 2) {
                    eventExtraHeight = (75 * eventYMax) + 25;
                } else if (eventYMax > 2) {
                    eventExtraHeight = (65 * eventYMax) + 25;
                }

                // console.log(recentEventsDetailMax, eventExtraWidth);

                // set the dimensions and margins of the graph
                const margin = {top: 50, right: 30, bottom: 100, left: 40};
                const width = 940;
                const height = 378 + margin.top + margin.bottom;

                // append the svg object to the body of the page
                var svg = d3.select("#" + this.id)
                    .append("svg")
                    .attr("preserveAspectRatio", "xMinYMin meet")
                    .attr("width", width)
                    .attr("height", height + margin.top + 100 + eventExtraHeight)
                    .attr("viewBox", `0 0 ${width + 75 + 10} ${height + margin.top + 100 + eventExtraHeight}`)
                    .append("g")
                    .attr("id", this.id + "-content")
                    .attr("transform", "translate(" + margin.left + ", 0)");


                const xRangeStart = dayjs(this.currentYearUserBirthdate).startOf("month");
                const xRangeEnd = dayjs(xRangeStart).add(1, "year");

                let x = d3.scaleTime()
                    .domain([xRangeStart, xRangeEnd])
                    .range([0, width]);

                const xAxisRangeType = d3.timeMonth;

                const xAxis = g => g
                    .attr("transform", `translate(0, ${height + 0})`)
                    .attr("class", "x-axis")
                    .call(d3.axisBottom(x)
                        .ticks(xAxisRangeType)
                        .tickFormat((data, index) => {
                            const formatTime = d3.timeFormat("%b %Y");
                            return formatTime(data);
                        })
                        .tickSizeInner(10)
                        .tickSizeOuter(15)
                    )
                    .call(g => g.select(".domain").remove());

                // Add Y axis
                const y = d3.scaleLinear()
                    .domain(adaptedYValueRange)
                    .range([ height, 0]);

                // Interactivity
                const mouseover = (d) => {
                    const target = d.target;

                    let element = d.target;
                    if (target.classList != "point__circle") {
                        element = target.parentNode.getElementsByClassName("point__circle")[0];
                    }
                    var all = document.getElementsByClassName("point-wrapper");
                    for (var i = 0; i < all.length; i++) {
                        all[i].style.opacity = 0.1;
                    }
                    // console.log(element.parentNode);
                    element.classList.add("hvr");
                    element.parentNode.style.opacity = 1;

                    let tooltip = target.parentNode.getElementsByClassName("point-active__tooltip")[0];
                    tooltip.style.display = "block";
                
                    // element.setAttribute("stroke-width", 22);
                };
                const click = (d) => {
                    // Do something on mouse click
                    const target = d.target;

                    let element = target;

                    if (target.classList !== "point__wrapper") {
                        element = target.parentNode;
                    }

                    this.$emit("show-domain-modal", element.dataset.domain);
                };
                const mouseleave = function(d) {
                    const target = d.target;

                    let element = target.getElementsByClassName("point__circle")[0];
                    var all = document.getElementsByClassName("point-wrapper");
                    for (var i = 0; i < all.length; i++) {
                        all[i].style.opacity = 1;
                    }
                    element.classList.remove("hvr");

                    let tooltip = target.parentNode.getElementsByClassName("point-active__tooltip");
                    for (var j = 0; j < tooltip.length; j++) {
                        tooltip[j].style.display = "none";
                    }
                    // element.setAttribute("stroke-width", 0);
                };

                const lineEvent = d3.line()
                    .x(d => d.x)
                    .y(d => d.y);

                if (this.cleanedEvents) {
                    var event = svg.append("g")
                        .selectAll("dot")
                        .data(this.cleanedEvents);

                    var eventGroup = event.enter()
                        .append("g")
                        .attr("class", (d) => {
                            let classContent = "event-wrapper";

                            return classContent;
                        })
                        .attr("transform", function(d) {
                            return "translate("+ x(d.x) + ", " + 600 + ")";
                        });

                    // Create the line bewteen start circle and end circle
                    eventGroup.append("path")
                        .attr("class", "link")
                        .attr("stroke", "#9a6fe3")
                        .attr("stroke-width", 2)
                        .attr("stroke-linecap", "round")
                        .attr("stroke-dasharray", "1, 8")
                        .attr("fill", "none")
                        .datum(d => {
                            const startPoint = {x: 0, y: 0};
                            let endPoint = {x: 0, y: (55 * d.y)};

                            const coordinates = [startPoint, endPoint];

                            return coordinates;
                        })
                        .attr("d", lineEvent);

                    var eventCircleStart = eventGroup.append("circle")
                        .attr("class", "event__circle")
                        .attr("r", 10)
                        .attr("fill", "#9a6fe3");

                    var eventDeleteGroup = eventGroup.append("g")
                        .attr("class", "event__delete-group")
                        .attr("data-id", (d) => {
                            return d.id_event;
                        })
                        .attr("data-owner", (d) => {
                            return d.id_user;
                        })
                        .attr("transform", function(d) {
                            return "translate(0, " + (55 * d.y) + ")";
                        });


                    var eventCircleEnd = eventDeleteGroup.append("circle")
                        .attr("class", "event__circle")
                        .attr("r", 10)
                        .attr("fill", (d) => {

                            if (d.id_user === this.loggedUserId) {
                                return "#f586cb";
                            }  else {
                                return "#9a6fe3";
                            }

                        })
                        .attr("stroke", (d) => {
                            if (d.id_user === this.loggedUserId) {
                                return "rgba(245, 134, 203, .2)";
                            } else {
                                return;
                            }
                        })
                        .attr("stroke-width", (d) => {
                            if (d.id_user === this.loggedUserId) {
                                return 16;
                            } else {
                                return 0;
                            }
                        });

                    eventGroup.append("g")
                        .attr("class", "event__content")
                        .attr("style", d => {
                            return "transform: translate(30px, " + (55 * d.y) + "px);";
                        })
                        .append("text")
                        .append("tspan")
                        .attr("class", "event__title")
                        .text((d) => {
                            return d.subcategory;
                        })
                        .select(function() {
                            return this.parentNode;
                        })
                        .append("tspan")
                        .attr("class", "event__detail")
                        .attr("x", "0")
                        .attr("y", "1.6em")
                        .text((d) => {
                            return d.detail;
                        });
                }

                const line = d3.line()
                    .x(d => x(d.x))
                    .y(d => y(d.y))
                    .curve(d3.curveBasis);

                svg.append("g")
                    .call(xAxis);

                /* Define the data for the circles */
                var point = svg.append("g")
                    .selectAll("dot")
                    .data(this.cleanedData);

                /* Create and place the "blocks" containing the circle and the text */
                var pointGroup = point.enter()
                    .append("g")
                    .attr("class", (d) => {
                        let classValue = "point-wrapper point-wrapper--active";

                        return classValue;
                    })
                    .attr("data-year", (d) => {
                        return dayjs(d.x).year();
                    })
                    .attr("data-domain", (d) => {
                        return d.domain;
                    })
                    .attr("data-desc", (d) => {
                        return d.desc;
                    })
                    .on("mouseover", mouseover)
                    .on("click", click)
                    .on("mouseleave", mouseleave);

                // Create the line bewteen axis circle and circle
                pointGroup.append("path")
                    .attr("class", "link")
                    .attr("stroke", (d) => {
                        return d.color;
                    })
                    .attr("stroke-width", 2)
                    .attr("stroke-linecap", "round")
                    .attr("stroke-dasharray", "1, 8")
                    .attr("fill", "none")
                    .datum(d => {
                        const startPoint = {x: d.x, y: 0};

                        const middlePoint = {x: dayjs(d.x).add(8, "day"), y: d.y / 3};
                        const endPoint = {x: dayjs(d.x).add(12, "day"), y: d.y};


                        const coordinates = [startPoint, middlePoint, endPoint];

                        return coordinates;
                    })
                    .attr("d", line);

                /*Create the circle for each block */
                pointGroup.append("circle")
                    .attr("class", "point__circle")
                    .attr("r", (d) => {
                        let pointRadius = 2 * d.value;
                        return pointRadius;
                    })
                    .attr("transform", (d) => {
                        const xOffset = x(dayjs(d.x).add(12, "day"));

                        return "translate("+ xOffset + ", " + y(d.y) + ")";
                    })
                    .attr("stroke", (d) => {
                        return hexToRgba(d.color, .2);
                    })
                    .attr("stroke-width", 0)
                    .attr("fill", (d) => {
                        return d.color;
                    });


                /* Create the text for each block */
                pointGroup.append("text")
                    .attr("class", "point__text")
                    .text((d, i) => {
                        let textContent = this.$t(d.domain + "-barometer");
                        return textContent;
                    })
                    .attr("transform", (d) => {
                        const xOffset = x(dayjs(d.x).add(12, "day"));

                        return "translate("+ xOffset + ", " + y(d.y) + ")";
                    })
                    .attr("fill", "#230854")
                    .attr("text-anchor", "middle")
                    .attr("dominant-baseline", "central");

                // Create the axis circle of each group
                pointGroup.append("circle")
                    .attr("class", "circle-axis")
                    .attr("r", (d) => {
                        let pointRadius = 10;
                        return pointRadius;
                    })
                    .attr("transform", function(d) {
                        return "translate("+ x(d.x) + ", " + y(0) + ")";
                    })
                    .attr("stroke-width", 1)
                    .attr("fill", (d) => {
                        return d.color;
                    });

                const tooltip = pointGroup.append("g")
                    .attr("class", "point-active__tooltip")
                    // .attr("style", "transform: translate(100px, 0);")
                    .attr("style", "display: none;")
                    .attr("transform", (d) => {
                        const xOffset = x(dayjs(d.x).add(30, "day"));
                        return "translate("+ xOffset + ", " + y(d.y) + ")";
                    });
                tooltip.append("rect")
                    .attr("class", "tooltip-rect")
                    .attr("y", -30)
                    .attr("rx", 10)
                    .attr("ry", 10)
                    .attr("width", 250)
                    .attr("height", 250);
                    
                tooltip.append("text")
                    .each(function(d){
                        // split name by space and -
                        var year = d.x.toLocaleString("en-us", { month: "long" }) + " "+d.x.getDate();
                        var title = d.domain;
                        var desc = d.desc;
                        var n = desc.match(/.{1,20}(\s|$)/g);
                        // get the current element
                        var text = d3.select(this);
                        text.append("tspan")
                            .attr("x", 5)
                            .attr("class", "point-active__tooltip-year")
                            .text(year);
                        text.append("tspan")
                            .attr("x", 5)
                            .attr("dy",1.6 + "em")
                            .attr("class", "point-active__tooltip-title")
                            .text(title);
                        // now loop
                        for (var i = 0; i < n.length; i++) {
                            text.append("tspan")
                                .attr("class", "point-active__tooltip-text")
                                .attr("x", 5)
                                .attr("dy", "1.6em")
                                .text(n[i]);
                        }
                    });

                // Resize SVG based on is content
                const svgContent = document.getElementById(this.id + "-content");

                if (svgContent) {
                    const svgContentWidth = svgContent.getBBox().width;


                    if (svgContentWidth) {

                        const svgElement = document.getElementById(this.id).childNodes[0];

                        if (svgElement) {
                            svgElement.setAttribute("width", svgContentWidth);
                            svgElement.setAttribute("viewBox", `0 0 ${svgContentWidth + 75 + 10} ${height + margin.top + 100 + eventExtraHeight}`);
                        }

                    }
                }
            });
        },
        handleMouseUp() {
            this.isMouseDown = false;
        },
        handleMouseDown() {
            this.isMouseDown = true;
            this.y = event.pageY;
            this.x = event.pageX;
            this.top = this.$el.scrollTop;
            this.left = this.$el.scrollLeft;
        },
        handleMouseMove(event) {
            this.isDragEnable = true;
            if (this.isDragEnable && this.isMouseDown) {
                this.$el.scrollLeft = this.left - event.pageX + this.x;
                this.$el.scrollTop = this.top - event.pageY + this.y;
            }
        },
        handleMouseLeave() {
            this.isDragEnable = false;
        }
        
    }
};
</script>

<style scoped>
.arrow-main{
    position: absolute;
    left: 10%;
    right: 10%;
     margin-top: -196px;
}

@media only screen and (max-width: 768px) {
    .arrow-main{
    left: 10px;
    right: 10px;
    margin-top: -170px;
}
}

</style>